<script lang="ts">
  import { _ } from 'svelte-i18n';
  import PlanReportCalendar from './PlanReportCalendar.svelte';
  import { num } from './format';
  import { barWidth, completionPercent } from './report';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  export let report: any;

  $: exec = report?.execution;
  $: trainingDays = exec?.consistency?.training_days ?? 0;
</script>

  <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
    <h2 class="text-lg font-semibold mb-3">{$_('report.execution.heading')}</h2>
    {#each [['low', 'low'], ['high', 'high'], ['peak', 'peak']] as [label, k]}
      <div class="mb-2">
        <div class="flex justify-between text-sm"><span>{$_('report.execution.intensity_' + label)}</span><span class="tabular-nums text-zinc-500">{$_('report.execution.of_xss', { values: { actual: num(exec.actual_xss[k], 0), prescribed: num(exec.prescribed_xss[k], 0), percent: completionPercent(exec.completion[k]) ?? '–' } })}</span></div>
        <div class="h-2 rounded bg-zinc-100"><div class="h-2 rounded bg-blue-500" style="width: {barWidth(exec.completion[k])}" /></div>
      </div>
    {/each}
    {#if exec.daily_component_compliance?.length}
      <div class="mt-4"><PlanReportCalendar days={exec.daily_component_compliance} /></div>
    {/if}
    <div class="mt-3 text-sm text-zinc-600">
      {#if trainingDays > 0}{$_('report.execution.completed', { values: { onTarget: exec.consistency.on_target, days: trainingDays, close: exec.consistency.close ?? 0 } })}{/if}
      {#if exec.rest_day_adherence?.rest_days} {$_('report.execution.rest_kept', { values: { kept: exec.rest_day_adherence.adhered, days: exec.rest_day_adherence.rest_days } })}{/if}
      {#if exec.off_plan?.activities} {$_('report.execution.off_plan', { values: { n: exec.off_plan.activities } })}{/if}
    </div>
    {#if exec.unplanned_xss && (exec.unplanned_xss.low + exec.unplanned_xss.high + exec.unplanned_xss.peak) >= 1}
      <p class="mt-2 text-sm text-zinc-600">{$_('report.execution.unplanned', { values: { low: num(exec.unplanned_xss.low), high: num(exec.unplanned_xss.high), peak: num(exec.unplanned_xss.peak) } })}</p>
    {/if}
    {#if exec.training_hours}<p class="mt-1 text-sm text-zinc-600">{$_('report.execution.hours', { values: { n: num(exec.training_hours, 1) } })}</p>{/if}
    <p class="mt-2 text-xs text-zinc-500">{$_('report.execution.circles')}</p>
  </section>
